export const MAP_FORM_DESC_THEME_CLASSNAMES = {
  info: 'bg-orange-100 text-gray-500',
  default: 'bg-gray-100 text-gray-500',
};
